module.exports = __webpack_public_path__ + "static/img/quality05.844f18b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quality05.jpg
// module id = k/RN
// module chunks = 1